import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Header from '~/components/header';
import { Wrapper } from './styles';
import Search from '~/components/search/index';
import PopupChat from '~/components/popupChat';
import ModalIptu from '~/components/modalIptu';

export default function DefaultLayout({ children }) {
  const path = children.props.location.pathname;

  useEffect(() => {

  })

  if (path !== '/MeusImoveis') {
    return (
      <Wrapper>
        <Header />
        <Search />
        {children}
        <ModalIptu/>
        <PopupChat/>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Header />
      {children}
      <PopupChat/>
      <ModalIptu/>
    </Wrapper>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
